// extracted by mini-css-extract-plugin
export default {"profile-container":"Profile_profile-container__IAn9Q","aiProfile-container":"Profile_aiProfile-container__9WTwQ"};